/*
 *  Created by SGiri 03/12/2018
 */

export class AdminConstant {

  public static GET_REQUEST_URL = '/biadmin/request';

  public static REQ_DENY_URL = '/biadmin/deny';

  public static REQ_APPROVE_URL = '/biadmin/approve';

  public static REQ_ROLLBACL_URL = '/biadmin/rollback';

  public static GET_ENVIRONMENT_URL = '/biadmin/environments';

  public static GET_CONTENT_URL = '/biadmin/content/';

  public static GET_ENVIRONMENT_USERS_URL = '/biadmin/users/';

  public static GET_USER_DATA = '/biadmin/getdata/';

  public static REQ_CREATE_URL = '/biadmin/newrequest';

  public static CREATE_DATASOURCE_URL = '/biadmin/createdatasource';

  public static CREATE_BULK_DATASOURCE_URL = '/biadmin/createbulkdatasource';

  public static GET_CONCISE_DATASOURCES_URL = '/biadmin/getconcisedatasources';

  public static GET_ROLES_URL = '/biadmin/getroles';

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/util/admin.constant.ts